import { render, staticRenderFns } from "./TheLoading.vue?vue&type=template&id=22433277&scoped=true&"
import script from "./TheLoading.vue?vue&type=script&lang=js&"
export * from "./TheLoading.vue?vue&type=script&lang=js&"
import style0 from "./TheLoading.vue?vue&type=style&index=0&id=22433277&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22433277",
  null
  
)

export default component.exports